import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import "./index.css";

// Redirect alias domains to primary domain before mounting React
const PRIMARY_DOMAIN = "dearestly.co";
const ALIAS_DOMAINS = ["circle.dearestly.co"];

if (ALIAS_DOMAINS.includes(window.location.hostname)) {
  window.location.replace(
    `https://${PRIMARY_DOMAIN}${window.location.pathname}${window.location.search}${window.location.hash}`
  );
} else {
  registerSW({ immediate: true });
  createRoot(document.getElementById("root")!).render(<App />);
}
